import React, { useEffect, useState, useContext } from 'react'
import { MainContext } from '../contexts/MainContext'

const NavBarCobru = () => {

    const { getServiceStyles } = useContext(MainContext);
    const serviceStyles = getServiceStyles();
    const isBitppiBrand = serviceStyles?.name === 'Bitppi';
    const isTengoBrand = serviceStyles?.name === 'Tengo';

    const [showNav, setShowNav] = useState('')

    const handleScroll = () => {
        const scroll = window.scrollY;

        if (scroll > 10) {
            setShowNav("show");
        } else {
            setShowNav("");
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        }
    }, [])
    
    return (
        <nav className={showNav}>
            <div className="wrapper">
                {isTengoBrand ? (
                    <div className="flex justify-center items-center">
                        <img src={serviceStyles.logo} alt={serviceStyles.name} />
                    </div>
                ) : (
                    <a className="flex justify-center items-center" href="https://cobru.co/">
                        <img
                            src={serviceStyles?.logo}
                            alt={serviceStyles?.name || 'Cobru'}
                            className={isBitppiBrand ? 'navbar-logo-bitppi' : ''}
                        />
                    </a>
                )}
            </div>
        </nav>
    )
}

export default NavBarCobru
